import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteDeviceMutation } from 'src/api/device';
import { useGlobalModals } from 'src/contexts/global-modals';

export const useDeleteDevice = () => {
  const {
    deleteDeviceModal,
    closeDeleteDeviceModal,
    openLoadingModal,
    closeLoadingModal,
  } = useGlobalModals();
  const { deleteDeviceMutation, isPending } = useDeleteDeviceMutation();
  const navigate = useNavigate();

  const open = deleteDeviceModal.opened;
  const deviceId = deleteDeviceModal.deviceId;

  console.log('deviceId', deviceId);


  const handleConfirm = useCallback(async () => {
    if (!deviceId) {
      return;
    }

    openLoadingModal(
      'Deleting device',
      'Please wait while we delete the device...'
    );
    closeDeleteDeviceModal();

    try {
      await deleteDeviceMutation(deviceId);
      navigate('/devices');
    } finally {
      closeLoadingModal();
    }
  }, [
    closeDeleteDeviceModal,
    closeLoadingModal,
    deleteDeviceMutation,
    deviceId,
    navigate,
    openLoadingModal,
  ]);

  const handleClose = useCallback(() => {
    closeDeleteDeviceModal();
  }, [closeDeleteDeviceModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
